const createFileAccessError = (url, status) => {
  const error = new Error(`Không thể truy cập tệp (${status}).`);
  error.status = status;
  error.url = url;
  return error;
};

export const fetchFileUrl = async (url, options = {}) => {
  if (!url) {
    const error = new Error('Không tìm thấy đường dẫn tệp.');
    error.code = 'FILE_URL_MISSING';
    throw error;
  }

  let response;
  try {
    response = await fetch(url, options);
  } catch (error) {
    error.code = error.code || 'FILE_NETWORK_ERROR';
    throw error;
  }

  if (!response.ok) {
    throw createFileAccessError(url, response.status);
  }

  return response;
};

export const checkFileUrl = (url) => fetchFileUrl(url, { method: 'HEAD' });
